var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnehmen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_1236",
    "data-name": "Gruppe 1236",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 51.126,
    viewBox: "0 0 48 51.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1998",
    "data-name": "Rechteck 1998",
    width: 48,
    height: 51.126,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1235",
    "data-name": "Gruppe 1235",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4216",
    "data-name": "Pfad 4216",
    d: "M210.776,73.516H198.033a3.915,3.915,0,0,1-.566-.017.8.8,0,0,1-.728-.753.78.78,0,0,1,.527-.895,2.127,2.127,0,0,1,.707-.089q12.849-.005,25.7,0a2.071,2.071,0,0,1,.659.074.864.864,0,0,1-.19,1.666,4.411,4.411,0,0,1-.567.014Z",
    transform: "translate(-182.213 -66.467)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4217",
    "data-name": "Pfad 4217",
    d: "M207.681,145.225h-9.7c-.881,0-1.306-.3-1.3-.885s.433-.875,1.32-.875h19.351c.922,0,1.362.3,1.352.9s-.429.867-1.324.867Z",
    transform: "translate(-182.177 -132.883)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4218",
    "data-name": "Pfad 4218",
    d: "M204.691,215.167h6.657a3.153,3.153,0,0,1,.566.027.86.86,0,0,1,.131,1.656,2.118,2.118,0,0,1-.66.074q-6.682.005-13.365,0a2.4,2.4,0,0,1-.611-.058.861.861,0,0,1,.113-1.682,4.036,4.036,0,0,1,.566-.02Z",
    transform: "translate(-182.264 -199.292)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4219",
    "data-name": "Pfad 4219",
    d: "M580.67,246.3v5.777a3.367,3.367,0,0,1-.027.566.811.811,0,0,1-.845.738.829.829,0,0,1-.863-.724,2.6,2.6,0,0,1-.029-.462V240.286c.032-.625.362-.981.9-.973a.862.862,0,0,1,.867.856.826.826,0,0,1-.005.1c.018.516.006,1.033.006,1.549q0,2.236,0,4.483",
    transform: "translate(-536.207 -221.662)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4220",
    "data-name": "Pfad 4220",
    d: "M578.92,455.775c0-.309-.023-.62,0-.926A.871.871,0,0,1,579.8,454a.845.845,0,0,1,.849.811,17.075,17.075,0,0,1,0,1.9.811.811,0,0,1-.821.8h-.021a.838.838,0,0,1-.885-.788v-.026c-.024-.313,0-.624,0-.932",
    transform: "translate(-536.212 -420.519)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4221",
    "data-name": "Pfad 4221",
    d: "M126.623,73.45c-.3,0-.585.013-.876,0a.87.87,0,0,1-.853-.807.845.845,0,0,1,.738-.913,14.3,14.3,0,0,1,2.058,0,.815.815,0,0,1,.711.9v.015a.835.835,0,0,1-.848.8c-.309.017-.617,0-.929,0",
    transform: "translate(-115.679 -66.405)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4222",
    "data-name": "Pfad 4222",
    d: "M126.75,215.275c.326,0,.655-.026.979.006a.777.777,0,0,1,.753.772.748.748,0,0,1-.567.892.787.787,0,0,1-.082.013,12.28,12.28,0,0,1-2.2-.005c-.443-.04-.648-.429-.645-.867a.829.829,0,0,1,.787-.811c.325-.027.653-.005.978-.005Z",
    transform: "translate(-115.767 -199.383)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4223",
    "data-name": "Pfad 4223",
    d: "M126.71,145.175c-.325,0-.654.024-.978-.006a.835.835,0,0,1-.791-.858.794.794,0,0,1,.737-.847h0a13.652,13.652,0,0,1,2.055.007.768.768,0,0,1,.712.82h0a.152.152,0,0,1-.005.048.829.829,0,0,1-.755.832,1.081,1.081,0,0,1-.154.015h-.823Z",
    transform: "translate(-115.725 -132.85)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4224",
    "data-name": "Pfad 4224",
    d: "M97.2,4.663A4.42,4.42,0,0,0,92.523.01H57.834a4.415,4.415,0,0,0-4.7,4.674V25.951a3.12,3.12,0,0,0,.018.516.876.876,0,0,0,1.727-.026,4.271,4.271,0,0,0,.013-.566V4.764a2.694,2.694,0,0,1,3-2.994H92.427a2.7,2.7,0,0,1,3.009,2.986v34.02h-.613c-1.738,0-3.476-.007-5.215.005a6.227,6.227,0,0,0-1.276.108,4.386,4.386,0,0,0-3.481,4.352c-.018,2.012,0,4.024,0,6.115h-.576c-.963,0-8.564-.01-9.526.005a.865.865,0,0,0-.867,1.19.912.912,0,0,0,.952.566c1.328,0,9.289-.015,10.614.006a1.475,1.475,0,0,0,1.139-.483Q91.65,45.56,96.732,40.5a1.505,1.505,0,0,0,.474-1.145Q97.2,22.006,97.2,4.663M86.613,47.875c0-1.543-.026-3.141.008-4.739a2.494,2.494,0,0,1,2.2-2.533c1.728-.087,3.467-.022,5.11-.022Z",
    transform: "translate(-49.207 0)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4225",
    "data-name": "Pfad 4225",
    d: "M16.794,345.6a3.773,3.773,0,0,1-2.686-1.113l-13-13a3.8,3.8,0,0,1,5.372-5.372L16.82,336.459l17.473-17.133a3.8,3.8,0,0,1,5.319,5.424L19.453,344.517a3.777,3.777,0,0,1-2.659,1.086m-13-18.9a2.1,2.1,0,0,0-1.486,3.587l13,13a2.1,2.1,0,0,0,2.958.014L38.424,323.54a2.1,2.1,0,1,0-2.943-3L16.808,338.847,5.283,327.322a2.1,2.1,0,0,0-1.486-.615",
    transform: "translate(0 -294.768)",
    fill: "#00c713"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnehmen);
export default __webpack_public_path__ + "static/media/annehmen.3079cada9f00cd1b747068598c29c2d9.svg";
export { ForwardRef as ReactComponent };